/**
 *
 * @Info
 * As a rule of thumb we name the exported action
 * in CamelCaseCaps and the actual action value in camelCase.
 */

// GLOBAL
export const TestAction = 'testAction';
export const ClearStore = 'clearStore';

// AUTH ACTIONS
export const SignUp = 'signUp';
export const Logout = 'logout';
export const SendResetPassword = 'sendResetPassword';
export const FetchOrganization = 'fetchOrganization';
export const UpdateOrganization = 'updateOrganization';
export const FetchUserData = 'fetchUserData';
export const UpdateUserData = 'updateUserData';
export const ChangePassword = 'changePassword';
export const OrgEnsured = 'orgEnsured';
export const ChangeActiveOrganization = 'changeActiveOrganization';
export const CreateNewConversation = 'createNewConversation';

// REFERENCE DIALOG
export const SetSelectedReferencePanel = 'setSelectedReferencePanel';
export const CloseReferencePanel = 'closeReferencePanel';

// CONVERSATION ACTIONS
export const EndMessage = 'endMessage';
export const UpdateMessageReferences = 'updateMessageReferences';
export const SetConversationScope = 'setConversationScope';
export const AddScopeMessage = 'addScopeMessage';
export const ReplaceScopeMessage = 'replaceScopeMessage';
export const RemoveScopeMessage = 'removeScopeMessage';
export const UpdateSystemMessageTranslationData = 'updateSystemMessageTranslationData';
export const SetCurrentConversationName = 'setCurrentConversationName';
export const SetConversationFilters = 'setConversationFilters';
export const SetInitialFilters = 'setInitialFilters';
export const SetIsNewConversation = 'setIsNewConversation';
export const SetConversationDefaultState = 'setConversationDefaultState';
export const SetIsAuthoringStarted = 'setIsAuthoringStarted';
export const SetExpandedFilters = 'setExpandedFilters';
export const SetAuthoringDefaultState = 'setAuthoringDefaultState';
export const SetTacticContextFilter = 'setTacticContextFilter';
export const ResetTacticContextFilter = 'resetTacticContextFilter';
export const SetSelectedValues = 'setSelectedValues';
export const SetIsResearchModeOn = 'setIsResearchModeOn';
export const UpdateGeneratedImagesData = 'updateGeneratedImagesData';
export const SetImageGenerationParams = 'setImageGenerationParams';
export const PopMessage = 'popMessage';

// USER IMAGES ACTIONS
export const SetBrandStyles = 'setBrandStyles';
export const SetRemixImage = 'setRemixImage';

// NOTIFICATION ACTIONS
export const MarkAllNotificationsAsRead = 'markAllNotificationsAsRead';
export const ClearNotificationById = 'clearNotificationById';
export const ClearAllNotifications = 'clearAllNotifications';

// MODALS
export const ShowTranslationModal = 'showTranslationModal';
export const HideTranslationModal = 'hideTranslationModal';
export const ShowPreviewDocument = 'showPreviewDocument';
export const ShowPreviewAuthorDocument = 'showPreviewAuthorDocument';
export const HidePreviewDocument = 'hidePreviewDocument';
export const HidePreviewAuthorDocument = 'hidePreviewAuthorDocument';
export const SetShowAddToCollectionPopup = 'setShowAddToCollectionPopup';
export const SetGlossaryModal = 'setGlossaryModal';
export const SetWarningPopup = 'setWarningPopup';
export const SetShowFilters = 'SetShowFilters';
export const SetShowFiles = 'SetShowFiles';
export const SetSharedLinkCollectionPopup = 'setSharedLinkCollectionPopup';
export const SetMediaPanelOpened = 'SetMediaPanelOpened';

// LANGUAGE
export const UpdateCurrentLanguageCode = 'updateCurrentLanguageCode';

// COLLECTIONS
export const AddToCollection = 'addToCollection';
export const RemoveFromCollection = 'removeFromCollection';
export const SetCollection = 'setCollection';
export const SetCollections = 'setCollections';
export const CreateCollection = 'createCollection';
export const RemoveCollection = 'removeCollection';
export const UpdateCollection = 'updateCollection';
export const SetCollectionThumbs = 'setCollectionThumbs';

//DOCUMENT EDITOR ACTIONS

export const SetSelectedObjectDocumentEditor = 'setSelectedObjectDocumentEditor';
export const SetCurrentDesignSystemDocumentElements = 'setCurrentDesignSystemDocumentElements';

export const SetAuthoredDocuments = 'setAuthoredDocuments';
export const SetSelectedAuthoredDocument = 'setSelectedAuthoredDocument';
export const DeleteAuthoredDocumentById = 'deleteAuthoredDocumentById';
export const AddDownloadInProgress = 'addDownloadInProgress';
export const RemoveDownloadInProgress = 'removeDownloadInProgress';
export const SetCurrentDsConfig = 'setCurrentDsConfig';
export const SetEmailTokens = 'setEmailTokens';

// FilterForm
export const SetFilters = 'setFilters';
export const SetFiltersObject = 'setFiltersObject';
export const SetTotalMediaImages = 'setTotalMediaImages';

// Footnotes
export const SetFootnotes = 'setFootnotes';
export const SetDisplayReferencesOnDocumentLevel = 'setDisplayReferencesOnDocumentLevel';

//Quick promots
export const SetCurrentFields = 'setCurrentFields';
export const SetDefaultPromptFields = 'setDefaultPromptFields';
export const SetPromptsDefaultState = 'setPromptsDefaultState';
export const SetCurrentPromptCard = 'setCurrentPromptCard';
export const SetDisplayPromptsInNewTab = 'setDisplayPromptsInNewTab';
export const SetPrompts = 'setPrompts';
export const SetCategories = 'setCategories';
export const SetSelectedCategories = 'setSelectedCategories';
